import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Collapse, Modal, Button, Alert } from "react-bootstrap";

const Awards = () => {
  const [collapseBtn, setCollapseBtn] = useState(true);
  const [awards, setAwards] = useState([]);

  const [formData, setFormData] = useState({
    category: "",
    year: "",
    name: "",
    role: "",
    institute: "",
    description: "",
  });

  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);

  // ALERT
  const [alert, setAlert] = useState({
    show: false,
    type: "",
    text: "",
  });

  // DELETE
  const [deleteId, setDeleteId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  // EDIT
  const [showModal, setShowModal] = useState(false);
  const [editId, setEditId] = useState(null);
  const [editImage, setEditImage] = useState(null);
  const [editData, setEditData] = useState({
    category: "",
    year: "",
    name: "",
    role: "",
    institute: "",
    description: "",
    image: "",
  });

  // ALERT FUNCTION
  const showAlert = (type, text) => {
    setAlert({ show: true, type, text });
    setTimeout(() => {
      setAlert({ show: false, type: "", text: "" });
    }, 3000);
  };

  // FETCH AWARDS
  const fetchAwards = async () => {
    try {
      const res = await fetch("https://admin.vascularirdoctors.com/backend/awards");
      const data = await res.json();
      setAwards(Array.isArray(data) ? data : []);
    } catch (err) {
      console.log("FETCH AWARDS ERROR:", err);
      showAlert("danger", "Unable to fetch awards.");
    }
  };

  useEffect(() => {
    fetchAwards();
  }, []);

  // CHANGE FORM
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleImage = (e) => {
    setImage(e.target.files[0]);
  };

  // ADD AWARD
  const submitHandler = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const data = new FormData();
      data.append("category", formData.category);
      data.append("year", formData.year);
      data.append("name", formData.name);
      data.append("role", formData.role);
      data.append("institute", formData.institute);
      data.append("description", formData.description);
      if (image) data.append("image", image);

      const res = await fetch("https://admin.vascularirdoctors.com/backend/awards", {
        method: "POST",
        body: data,
      });

      const result = await res.json();

      if (res.ok) {
        showAlert("success", "Award added successfully.");
        setFormData({
          category: "",
          year: "",
          name: "",
          role: "",
          institute: "",
          description: "",
        });
        setImage(null);
        fetchAwards();
      } else {
        showAlert("danger", result.message || "Failed to add award.");
      }
    } catch (err) {
      console.log("ADD AWARD ERROR:", err);
      showAlert("danger", "Unable to connect to server.");
    }

    setLoading(false);
  };

  // DELETE
  const confirmDelete = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const deleteAward = async () => {
    try {
      const res = await fetch(`https://admin.vascularirdoctors.com/backend/awards/${deleteId}`, {
        method: "DELETE",
      });

      const result = await res.json();

      if (res.ok) {
        showAlert("success", "Award deleted successfully.");
        fetchAwards();
      } else {
        showAlert("danger", result.message || "Delete failed.");
      }
    } catch (err) {
      console.log("DELETE ERROR:", err);
      showAlert("danger", "Unable to delete award.");
    }

    setShowDeleteModal(false);
    setDeleteId(null);
  };

  // OPEN EDIT
  const openEditModal = (award) => {
    setEditId(award.id);
    setEditData({
      category: award.category || "",
      year: award.year || "",
      name: award.name || "",
      role: award.role || "",
      institute: award.institute || "",
      description: award.description || "",
      image: award.image || "",
    });
    setEditImage(null);
    setShowModal(true);
  };

  const handleEditChange = (e) => {
    setEditData({
      ...editData,
      [e.target.name]: e.target.value,
    });
  };

  const handleEditImage = (e) => {
    setEditImage(e.target.files[0]);
  };

  // UPDATE
  const updateAward = async () => {
    try {
      const data = new FormData();
      data.append("category", editData.category);
      data.append("year", editData.year);
      data.append("name", editData.name);
      data.append("role", editData.role);
      data.append("institute", editData.institute);
      data.append("description", editData.description);
      if (editImage) data.append("image", editImage);

      const res = await fetch(`https://admin.vascularirdoctors.com/backend/awards/${editId}`, {
        method: "PUT",
        body: data,
      });

      const result = await res.json();

      if (res.ok) {
        showAlert("success", "Award updated successfully.");
        setShowModal(false);
        fetchAwards();
      } else {
        showAlert("danger", result.message || "Update failed.");
      }
    } catch (err) {
      console.log("UPDATE ERROR:", err);
      showAlert("danger", "Unable to update award.");
    }
  };

  return (
    <>
      <div className="row">
        <div className="col-xl-12">
          <div className="row page-titles align-items-center">
            <div className="col-sm-6">
              <ol className="breadcrumb mt-sm-0 mt-2">
             
                <li className="breadcrumb-item active">Awards</li>
              </ol>
            </div>

            <div className="col-sm-6 text-sm-end mt-2 mt-sm-0">
              <button
                type="button"
                className="btn btn-outline-danger btn-sm"
                onClick={() => setCollapseBtn(false)}
              >
                <i className="fas fa-times me-1"></i> Close
              </button>
            </div>
          </div>
        </div>

        {/* ALERT */}
        {alert.show && (
          <div className="col-xl-12">
            <Alert variant={alert.type} className="shadow-sm rounded-3">
              {alert.text}
            </Alert>
          </div>
        )}

        {/* ADD FORM */}
        <div className="col-xl-12">
          <div className="filter cm-content-box box-primary">
            <div className="content-title d-flex justify-content-between align-items-center">
              <div className="cpa">
                <i className="fas fa-award me-1"></i>Add Award
              </div>
              <div className="tools">
                <button
                  type="button"
                  className="btn btn-sm btn-light border"
                  onClick={() => setCollapseBtn(!collapseBtn)}
                >
                  <i
                    className={`fas ${
                      collapseBtn ? "fa-angle-up" : "fa-angle-down"
                    }`}
                  ></i>
                </button>
              </div>
            </div>

            <Collapse in={collapseBtn}>
              <div className="cm-content-body form excerpt">
                <div className="card-body">
                  <form onSubmit={submitHandler}>
                    <div className="row">
                      {/* LEFT */}
                      <div className="col-xl-6">
                        <div className="mb-3">
                          <label className="form-label">Award Category</label>
                          <input
                            type="text"
                            className="form-control"
                            name="category"
                            value={formData.category}
                            onChange={handleChange}
                            placeholder="Example: Gold Medal"
                            required
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Year</label>
                          <input
                            type="text"
                            className="form-control"
                            name="year"
                            value={formData.year}
                            onChange={handleChange}
                            placeholder="Example: 2025"
                            required
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Awardee Name</label>
                          <input
                            type="text"
                            className="form-control"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            placeholder="Enter awardee name"
                            required
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Role / Title</label>
                          <input
                            type="text"
                            className="form-control"
                            name="role"
                            value={formData.role}
                            onChange={handleChange}
                            placeholder="Example: Gold Medal Awardee"
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Institute / Location</label>
                          <input
                            type="text"
                            className="form-control"
                            name="institute"
                            value={formData.institute}
                            onChange={handleChange}
                            placeholder="Example: Chandigarh, India"
                          />
                        </div>
                      </div>

                      {/* RIGHT */}
                      <div className="col-xl-6">
                        <div className="mb-3">
                          <label className="form-label">Award Description</label>
                          <textarea
                            className="form-control"
                            rows="8"
                            name="description"
                            value={formData.description}
                            onChange={handleChange}
                            placeholder="Write award details..."
                          ></textarea>
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Upload Award Image</label>
                          <input
                            type="file"
                            className="form-control"
                            onChange={handleImage}
                            accept="image/*"
                          />
                        </div>

                        {image && (
                          <div className="mb-3">
                            <img
                              src={URL.createObjectURL(image)}
                              alt="Preview"
                              style={{
                                width: "100%",
                                maxHeight: "220px",
                                objectFit: "cover",
                                borderRadius: "12px",
                                border: "1px solid #ddd",
                              }}
                            />
                          </div>
                        )}
                      </div>

                      <div className="col-xl-12 text-end">
                        <button
                          type="submit"
                          className="btn btn-primary"
                          disabled={loading}
                        >
                          {loading ? "Saving..." : "Save Award"}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </Collapse>
          </div>
        </div>

        {/* AWARD LIST */}
        <div className="col-xl-12 mt-4">
          <div className="filter cm-content-box box-primary">
            <div className="content-title">
              <div className="cpa">
                <i className="fas fa-list me-1"></i>Uploaded Awards
              </div>
            </div>

            <div className="card-body">
              <div className="table-responsive">
                <table className="table table-bordered table-striped align-middle">
                  <thead>
                    <tr>
                      <th>Image</th>
                      <th>Category</th>
                      <th>Year</th>
                      <th>Name</th>
                      <th>Institute</th>
                      <th style={{ width: "170px" }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {awards.length > 0 ? (
                      awards.map((item) => (
                        <tr key={item.id}>
                          <td>
                            <img
                              src={
                                item.image
                                  ? `https://admin.vascularirdoctors.com/backend${item.image}`
                                  : "https://via.placeholder.com/90x60?text=No+Image"
                              }
                              alt={item.name}
                              style={{
                                width: "90px",
                                height: "60px",
                                objectFit: "cover",
                                borderRadius: "8px",
                              }}
                            />
                          </td>
                          <td>{item.category}</td>
                          <td>{item.year}</td>
                          <td>{item.name}</td>
                          <td>{item.institute}</td>
                          <td>
                            <button
                              className="btn btn-sm btn-info me-2"
                              onClick={() => openEditModal(item)}
                            >
                              Edit
                            </button>
                            <button
                              className="btn btn-sm btn-danger"
                              onClick={() => confirmDelete(item.id)}
                            >
                              Delete
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6" className="text-center">
                          No awards found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* EDIT MODAL */}
      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit Award</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label>Category</label>
              <input
                type="text"
                className="form-control"
                name="category"
                value={editData.category}
                onChange={handleEditChange}
              />
            </div>

            <div className="col-md-6 mb-3">
              <label>Year</label>
              <input
                type="text"
                className="form-control"
                name="year"
                value={editData.year}
                onChange={handleEditChange}
              />
            </div>

            <div className="col-md-6 mb-3">
              <label>Name</label>
              <input
                type="text"
                className="form-control"
                name="name"
                value={editData.name}
                onChange={handleEditChange}
              />
            </div>

            <div className="col-md-6 mb-3">
              <label>Role</label>
              <input
                type="text"
                className="form-control"
                name="role"
                value={editData.role}
                onChange={handleEditChange}
              />
            </div>

            <div className="col-md-12 mb-3">
              <label>Institute</label>
              <input
                type="text"
                className="form-control"
                name="institute"
                value={editData.institute}
                onChange={handleEditChange}
              />
            </div>

            <div className="col-md-12 mb-3">
              <label>Description</label>
              <textarea
                className="form-control"
                rows="5"
                name="description"
                value={editData.description}
                onChange={handleEditChange}
              ></textarea>
            </div>

            <div className="col-md-12 mb-3">
              <label>Change Image</label>
              <input
                type="file"
                className="form-control"
                onChange={handleEditImage}
                accept="image/*"
              />
            </div>

            <div className="col-md-12">
              <img
                src={
                  editImage
                    ? URL.createObjectURL(editImage)
                    : editData.image
                    ? `https://admin.vascularirdoctors.com/backend${editData.image}`
                    : "https://via.placeholder.com/600x250?text=No+Image"
                }
                alt="Preview"
                style={{
                  width: "100%",
                  maxHeight: "250px",
                  objectFit: "cover",
                  borderRadius: "10px",
                }}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={updateAward}>
            Update Award
          </Button>
        </Modal.Footer>
      </Modal>

      {/* DELETE MODAL */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Delete Award</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this award? This action cannot be undone.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={deleteAward}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Awards;